import { action } from 'satcheljs';
/**
 * Called when there is a change in the remove old meeting message option
 */
var selectOldMeetingMessageOption = action('selectOldMeetingMessageOption', function (removeOldMeetingMessages) { return ({
    removeOldMeetingMessages: removeOldMeetingMessages,
}); });
export default selectOldMeetingMessageOption;
//# sourceMappingURL=selectOldMeetingMessageOption.js.map